<app-grid
  #grid
  *ngIf="!loading"
  [columnDefs]="columnDef"
  [rowData]="rowData"
  [rowSelection]="'multiple'"
  [selectedProject]="selectedProject"
  [suppressRowClickSelection]="true"
  [useSelectAll]="true"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onSelectedAllChanged()"
/>

<app-loading *ngIf="loading"/>
